export default "__VITE_ASSET__5Gmc9sGn__"